import * as React from "react";

import { InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland } from "../../../Common";

export interface ReactForgotPasswordInitialStateInterface {
  forgot_password_form_recaptcha: InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland;

  store_code: string;

  form_key: string;
}

interface ReactForgotPasswordInitialStateConsumerInterface {
  initialState: ReactForgotPasswordInitialStateInterface;
}

const defaultValue = {
  initialState: {} as ReactForgotPasswordInitialStateInterface,
} as unknown as ReactForgotPasswordInitialStateConsumerInterface;

const ReactForgotPasswordInitialStateContext =
  React.createContext(defaultValue);

interface ReactForgotPasswordInitialStateProviderProps {
  mountElement: Element | null;
}

export const ReactForgotPasswordInitialStateProvider: React.FunctionComponent<
  ReactForgotPasswordInitialStateProviderProps
> = (props) => {
  const initialState = React.useMemo(() => {
    const mountElement = (props.mountElement || {}) as HTMLElement;

    const initialStateJsonString =
      mountElement?.dataset.reactForgotPassword__initialstate || "{}";

    const initialState = JSON.parse(
      initialStateJsonString
    ) as ReactForgotPasswordInitialStateInterface;
    return initialState;
  }, [props.mountElement]);
  return (
    <ReactForgotPasswordInitialStateContext.Provider value={{ initialState }}>
      {props.children}
    </ReactForgotPasswordInitialStateContext.Provider>
  );
};

export const useReactForgotPasswordInitialState = () => {
  const context = React.useContext(ReactForgotPasswordInitialStateContext);
  if (context === defaultValue) {
    throw new Error(
      "useReactForgotPasswordInitialState must be used within a <ReactForgotPasswordInitialStateProvider>"
    );
  }
  return context;
};
